var _rect, _rect2, _path, _path2, _path3, _rect3, _rect4, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerDuplo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 415,
    viewBox: "0 0 430 415",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 0.5,
    width: 194,
    height: 414,
    rx: 9.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 0.5,
    width: 194,
    height: 414,
    rx: 9.5,
    stroke: "#767D8C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.25 174.25H87.75C83.6079 174.25 80.25 177.608 80.25 181.75V234.25C80.25 238.392 83.6079 241.75 87.75 241.75H140.25C144.392 241.75 147.75 238.392 147.75 234.25V181.75C147.75 177.608 144.392 174.25 140.25 174.25Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.875 200.5C103.982 200.5 106.5 197.982 106.5 194.875C106.5 191.768 103.982 189.25 100.875 189.25C97.7684 189.25 95.25 191.768 95.25 194.875C95.25 197.982 97.7684 200.5 100.875 200.5Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M147.75 219.25L129 200.5L87.75 241.75",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 219.5,
    y: 0.5,
    width: 194,
    height: 414,
    rx: 9.5,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 219.5,
    y: 0.5,
    width: 194,
    height: 414,
    rx: 9.5,
    stroke: "#767D8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M343.25 174.25H290.75C286.608 174.25 283.25 177.608 283.25 181.75V234.25C283.25 238.392 286.608 241.75 290.75 241.75H343.25C347.392 241.75 350.75 238.392 350.75 234.25V181.75C350.75 177.608 347.392 174.25 343.25 174.25Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M303.875 200.5C306.982 200.5 309.5 197.982 309.5 194.875C309.5 191.768 306.982 189.25 303.875 189.25C300.768 189.25 298.25 191.768 298.25 194.875C298.25 197.982 300.768 200.5 303.875 200.5Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M350.75 219.25L332 200.5L290.75 241.75",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerDuplo);
export default __webpack_public_path__ + "static/media/bannerDuplo.e92b0c8d2156b43ad3a1e409ddb06519.svg";
export { ForwardRef as ReactComponent };